var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn btn-link",attrs:{"href":`javascript:history.go(${_vm.go})`,"aria-label":"Back"}},[_c('IconChevronLeft',{staticClass:"chevron"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }